import { render, staticRenderFns } from "./BillboardEdit.vue?vue&type=template&id=3d7c43e0&"
import script from "./BillboardEdit.vue?vue&type=script&lang=ts&"
export * from "./BillboardEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports